import { useTabsStore } from '../../store/tabsStore';
import { normalizeRequestBodyMode } from '../../utils/requestBodyMode';
import { normalizeMock } from '../../utils/workspaceTabPersistence';
import { defaultRequestAuth } from '../../utils/requestAuth';

/** The request fields a tab shows — the same set useTabs builds a tab from. */
function tabFieldsOf(r) {
  const mode = normalizeRequestBodyMode(r || {});
  return {
    name: r.name,
    method: r.method || 'GET',
    url: r.url || '',
    headers: r.headers || [{ key: '', value: '', enabled: true }],
    params: r.params || [{ key: '', value: '', enabled: true }],
    cookies: r.cookies || [{ key: '', value: '', enabled: true }],
    body: r.body || '',
    bodyType: mode.bodyType,
    rawBodyLanguage: mode.rawBodyLanguage,
    formDataFields: r.formDataFields ?? undefined,
    auth: r.auth || defaultRequestAuth(),
    preRequestScript: r.preRequestScript ?? '',
    testScript: r.testScript ?? '',
    mock: normalizeMock(r.mock),
  };
}

/**
 * After a git version was applied (Restore, Discard, a pull), the open tabs
 * of the requests it changed show it — like an editor reloading a file that
 * changed on disk. A tab with unsaved edits is left alone (those edits are
 * the user's; the editor keeps them, as VS Code keeps a dirty buffer).
 *
 * @returns {number} how many tabs were refreshed
 */
export function refreshOpenTabsFrom(collections = []) {
  const byId = new Map();
  for (const c of collections || []) for (const r of c.requests || []) byId.set(String(r.id), r);
  const { requestTabs, setRequestTabs, requestTabSyncRevision, setRequestTabSyncRevision } = useTabsStore.getState();
  let changed = 0;
  const next = (requestTabs || []).map((t) => {
    if (t.originalId == null || t.hasUnsavedChanges) return t;
    const r = byId.get(String(t.originalId));
    if (!r) return t;
    changed += 1;
    return { ...t, ...tabFieldsOf(r), hasUnsavedChanges: false };
  });
  if (changed) {
    setRequestTabs(next);
    setRequestTabSyncRevision((requestTabSyncRevision || 0) + 1);
  }
  return changed;
}
